import React, { Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
//import SinglePostGenerator from "../components/PostGenerator/SinglePostGenerator/SinglePostGenerator";
const SinglePostGenerator = lazy(() =>
  import(
    /* webpackChunkName: "SinglePostGenerator" */ "../components/PostGenerator/SinglePostGenerator/SinglePostGenerator"
  )
);

// Redux stuff
import { connect } from "react-redux";
import { updateZoom } from "../redux/actions/templateActions";

function singlePostGenerator(props) {
  return (
    <Fragment>
      <CustomMeta
        title={`Single post generator`}
        description={`Used for single post generation`}
        url={`https://contentgenerator.io/singlePostGenerator`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <SinglePostGenerator />
        </Suspense>
      )}
    </Fragment>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { updateZoom })(singlePostGenerator);
